import { Link } from "react-router-dom";
import ArticleListItem from "@/components/base/ArticleListItem";
import { searchArticles } from "@/lib/news";

interface SearchResultsProps {
  keyword: string;
}

export default function SearchResults({ keyword }: SearchResultsProps) {
  const results = searchArticles(keyword);

  return (
    <section className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
      <div className="mb-6 rounded-lg border border-background-200 bg-background-100 p-5">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div>
            <h1 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              搜索结果：{keyword}
            </h1>
            <p className="mt-2 text-sm text-foreground-500">
              共找到 {results.length} 条相关内容 · 搜索为前端演示，仅筛选站内示例数据
            </p>
          </div>
          <Link
            to="/"
            className="whitespace-nowrap rounded-md border border-background-300 px-3 py-2 text-sm font-label text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer"
          >
            返回首页
          </Link>
        </div>
      </div>

      {results.length > 0 ? (
        <div className="space-y-3">
          {results.map((article, index) => (
            <ArticleListItem key={article.id} article={article} order={index} />
          ))}
        </div>
      ) : (
        <EmptyState keyword={keyword} />
      )}
    </section>
  );
}

function EmptyState({ keyword }: { keyword: string }) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-50 py-16 text-center">
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-secondary-100 text-secondary-500">
        <i className="ri-file-search-line text-2xl" />
      </span>
      <p className="mt-4 font-heading text-base font-semibold text-foreground-800">
        未找到与“{keyword}”相关的黑料信息
      </p>
      <p className="mt-2 text-sm text-foreground-500">
        换个关键词试试，或返回首页浏览最新动态。
      </p>
      <Link
        to="/"
        className="mt-5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-label text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
      >
        重置搜索
      </Link>
    </div>
  );
}